export default __webpack_public_path__ + "static/media/Drawer.cdddeb14.svg";